export const OFFERS_LIST_SUCCESS = "OFFERS_LIST_SUCCESS";
export const OFFERS_INFO_SUCCESS = "OFFERS_INFO_SUCCESS";
export const OFFERS_CREATE_SUCCESS = "OFFERS_CREATE_SUCCESS";
export const OFFERS_UPDATE_SUCCESS = "OFFERS_UPDATE_SUCCESS";
export const OFFERS_DELETE_SUCCESS = "OFFERS_DELETE_SUCCESS";
export const OFFERS_STATUS_SUCCESS = "OFFERS_STATUS_SUCCESS";
export const CLEAR_OFFERS_INFO = "CLEAR_OFFERS_INFO";
